import React from 'react';
import { CJK_GLYPH_FONT_FAMILY } from '../types/program';

interface SectionGlyphProps {
  /** A single decorative Chinese character (e.g. from getProgramTypeGlyph). */
  char: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * A decorative single-character CJK glyph, inspired by the BHCS marketing site
 * where each section is anchored by one bold Chinese character.
 *
 * Purely decorative — always rendered with aria-hidden so screen readers skip it;
 * the surrounding English label carries the real meaning. Callers control size,
 * color, opacity, and positioning via className/style.
 */
export const SectionGlyph: React.FC<SectionGlyphProps> = ({ char, className = '', style }) => (
  <span
    aria-hidden="true"
    className={`select-none font-bold leading-none ${className}`}
    style={{ fontFamily: CJK_GLYPH_FONT_FAMILY, ...style }}
  >
    {char}
  </span>
);
